module.exports = __webpack_public_path__ + "img/s3.aac56a3a.png";